import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

/**
 * Resposta de GET /api/calculadora/dados-abertos/versao.
 * Shape derivado de captura real (curl). Campos opcionais por robustez: uma
 * resposta parcial não deve quebrar quem consome (ver textoVersao no componente).
 */
export interface VersaoExecucao {
  versaoApp?: string;
  versaoDb?: string;
  descricaoVersaoDb?: string;
  dataVersaoDb?: string;
  ambiente?: string;
}

/**
 * Resposta de GET /api/versao/status (perfil offline).
 * Shape derivado de captura real (curl).
 */
export interface VersaoStatusOffline {
  aplicacaoAtualizada: boolean;
  dbAtualizada: boolean;
  dataDbAtualizada: boolean;
  versaoAplicacaoLocal?: string;
  versaoAplicacaoRemota?: string;
  versaoDbLocal?: string;
  versaoDbRemota?: string;
  dataDbLocal?: string;
  dataDbRemota?: string;
}

@Injectable({
  providedIn: 'root'
})
export class VersaoService {
  private baseUrl = environment.APIEndpoint;

  constructor(private http: HttpClient) {}

  /** Versão em execução (app + banco + ambiente). */
  obterVersao(): Observable<VersaoExecucao> {
    return this.http.get<VersaoExecucao>(`${this.baseUrl}/calculadora/dados-abertos/versao`);
  }

  /** Status de atualização no perfil offline (app/db local vs remoto). */
  obterStatusVersaoOffline(): Observable<VersaoStatusOffline> {
    return this.http.get<VersaoStatusOffline>(`${this.baseUrl}/versao/status`);
  }
}